<template>
  <keep-alive>
    <div class="goodsBox" v-cloak>
      <div class="box_filter_top">
        <div class="box_filter">
          <div class="box_filter_shaixuan" @click="boxFilterUnfold()">
            筛选
            <div style="display: inline-block;">
              <img :src="logo" alt class="img_zhankai" />
            </div>
            <el-tag
              onClick="event.cancelBubble = true"
              :key="index"
              v-for="(tag, index) in dynamicTags.flat(Infinity)"
              closable
              :type="tag.type"
              :disable-transitions="false"
              @close="handleClose(tag)"
              >{{ tag | categoryFilter }}</el-tag
            >
          </div>
          <div
            class="box_filter_zhankai"
            v-if="dynamicTags.length > 0 ? true : false"
          >
            <span class="box_filter_qingkong" @click="deleteFilet">清空</span>
          </div>
        </div>
        <div v-show="show_guanjianci">
          <div style="border: 1px solid #eee" class="box_biankuang_shuaixuan">
            <div>
              <!-- 大类 -->
              <div class="box_filter_xilie" v-if="KeyWordsList.broadHeading">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center;"
                  >大类：</span
                >
                <div class="box_fliter_xl_gengduo">
                  <div
                    v-for="(item, index) in KeyWordsList.broadHeading"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXL(item)"
                  >
                    {{ item }}类
                  </div>
                </div>
              </div>
              <!-- 品类名称 -->
              <div
                class="box_filter_xuxian"
                v-if="KeyWordsList.broadHeading && KeyWordsList.category"
              ></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.category">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >品类名称：</span
                >
                <div class="box_fliter_xiangfa_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.category"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('品类名称', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showxfcp">
                  {{ FilterXFGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 款式 -->
              <div class="box_filter_xuxian" v-if="KeyWordsList.style"></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.style">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >款式：</span
                >
                <div class="box_fliter_xiangfa_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.style"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('款式', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showxfcp">
                  {{ FilterXFGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 材质 -->
              <div class="box_filter_xuxian" v-if="KeyWordsList.texture"></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.texture">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >材质：</span
                >
                <div class="box_fliter_xiangfa_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.texture"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('材质', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showxfcp">
                  {{ FilterXFGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 工艺 -->
              <div
                class="box_filter_xuxian"
                v-if="KeyWordsList.technology"
              ></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.technology">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >工艺：</span
                >
                <div class="box_fliter_xiangfa_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.technology"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('工艺', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showxfcp">
                  {{ FilterXFGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 计价方式 -->
              <div
                class="box_filter_xuxian"
                v-if="KeyWordsList.pricingManner"
              ></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.pricingManner">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >计价方式：</span
                >
                <div class="box_fliter_bixing_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.pricingManner"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('计价方式', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showbxcp">
                  {{ FilterBXGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 宝石 -->
              <div class="box_filter_xuxian" v-if="KeyWordsList.gem"></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.gem">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >宝石：</span
                >
                <div class="box_fliter_bixing_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.gem"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('宝石', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showbxcp">
                  {{ FilterBXGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 扣子类型 -->
              <div class="box_filter_xuxian" v-if="KeyWordsList.button"></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.button">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >扣子类型：</span
                >
                <div class="box_fliter_bixing_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.button"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('扣子类型', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showbxcp">
                  {{ FilterBXGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 尺寸 -->
              <div class="box_filter_xuxian" v-if="KeyWordsList.size"></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.size">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >尺寸：</span
                >
                <div class="box_fliter_bixing_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.size"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('尺寸', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showbxcp">
                  {{ FilterBXGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 是否可调节 -->
              <div
                class="box_filter_xuxian"
                v-if="KeyWordsList.adjustable"
              ></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.adjustable">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >是否可调节：</span
                >
                <div class="box_fliter_bixing_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.adjustable"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('是否可调节', item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showbxcp">
                  {{ FilterBXGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 克重 -->
              <div
                class="box_filter_xuxian"
                v-if="KeyWordsList.gramWeight"
              ></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.gramWeight">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >克重：</span
                >
                <div class="box_fliter_bixing_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.gramWeight"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('克重', item)"
                  >
                    {{ item | categoryFilter }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showbxcp">
                  {{ FilterBXGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
              <!-- 价格 -->
              <div class="box_filter_xuxian" v-if="KeyWordsList.price"></div>
              <div class="box_filter_xilie" v-if="KeyWordsList.price">
                <span
                  style="font-size: 16px; float: left; color: #999;display:inline-block;width:100px;text-align: center"
                  >价格：</span
                >
                <div class="box_fliter_bixing_mc">
                  <div
                    v-for="(item, index) in KeyWordsList.price"
                    :key="index"
                    class="box_fliter_xl_mc"
                    @click="getFilterXF('价格', item)"
                  >
                    {{ item | categoryFilter }}
                  </div>
                </div>
                <!-- <div class="box_filter_xf_gengduo" @click="showbxcp">
                  {{ FilterBXGD }}
                  <div
                    class="box_filter_hezi"
                    style="margin-right: 9px; margin-left: 12px"
                  ></div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_sort">
        <span class="home_sort_hotal">共{{ total }}款</span>
        <div class="sortClass">排序</div>
        <div
          class="sales"
          style="border-right:none"
          :class="[classFlag ? 'classColor' : '']"
          @click.stop="salesSelection('sales')"
        >
          销量<span v-if="!classFlag">－</span>
        </div>
        <div
          class="sales"
          :class="[classFlagTwo ? 'classColor' : '']"
          @click.stop="salesSelection('newTime')"
        >
          新品<span v-if="!classFlagTwo">－</span>
        </div>
        <div class="priceRangeClass">
          <el-input
            size="mini"
            placeholder="请输入分数段"
            v-model="SPlist.start"
            @keyup.enter.native="getAxiosSp()"
          ></el-input
          >－
          <el-input
            size="mini"
            placeholder="请输入分数段"
            v-model="SPlist.end"
            @keyup.enter.native="getAxiosSp()"
          ></el-input>
        </div>
        <div class="determine" @click="getAxiosSp()">确定</div>
      </div>
      <div
        v-loading="loading"
        element-loading-text="正在加载数据"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0,.1)"
      >
        <div class="box_Img box_Img_top">
          <div
            v-for="(item, index) in datalist"
            class="box_Img_list"
            @click="getitem(item)"
            :key="index"
            @mouseenter="mouseOver(item)"
            @mouseleave="mouseLeave(item)"
          >
            <div class="box_Img_chirld">
              <img :src="item.imgPath" alt class="img_chirld" />
            </div>
            <div class="box_detail_name">
              <div style="display: inline-block">
                <div class="box_SP_bianhao">{{ item.styleNumber }}</div>
                <div class="box_SP_title">
                  {{ item.generaName }} {{ item.categoryName }}
                </div>
              </div>
              <div
                style="font-size:16px;color:#999999"
                class="salesNumbersClass"
                v-if="!item.gouwuche"
              >
                月销：{{ parseInt(item.salesNumbers) }}件
              </div>
              <div
                style="display: inline-block"
                class="shoppingpush"
                v-if="item.gouwuche"
                @click.stop="getitem(item)"
              >
                <img src="../Img/List/shoppingPush.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="withWithoutShow" style="text-align:center;margin:60px 0">
        <img src="../Img/noData.png" alt />
      </div>
      <div class="boe_fenye">
        <div style="display: inline-block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 40, 60, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </keep-alive>
</template>
<script>
import bus from "@/utils/bus";
import $ from "jquery";
export default {
  data() {
    return {
      loading: false,
      total: 0,
      dynamicTags: [[], [], [], [], [], [], [], [], [], [], [], []],
      logo: require("../Img/List/shouqi.png"),
      state: 1,
      keyword: "",
      show_guanjianci: true,
      input4: "",
      withWithoutShow: false,
      datalist: [],
      salesFlag: true,
      classFlag: false,
      classFlagTwo: false,
      newTimeFlag: true,
      KeyWordsList: [],
      FilterKSGD: "更多",
      FilterPLGD: "更多",
      FilterBXGD: "更多",
      FilterXFGD: "更多",
      pageNum: 1,
      toGetData: true,
      pageSize: 20,
      Unfold: "展开",
      titleType: "产品列表",
      SPlist: {
        broadHeading: "", //大类
        category: "", //品类
        style: "", //款式
        type: "list",
        texture: [], //材质
        technology: [], //工艺
        pricingManner: "", //计价方式
        gem: [], //宝石
        button: "", //扣子类型
        size: [], //尺寸
        gramWeight: [], //克重
        adjustable: "", //是否可调节
        price: [], //价格
        sortName: "", //排序字段
        sortType: "", //排序方式
        keyword: "",
        start: "",
        end: "",
      },
    };
  },
  mounted() {
    this.getAxios();
    this.getAxiosSp();
    bus.$on("handleSelect", (e) => {
      if (e == "1") {
        this.SPlist.type = "list";
        this.titleType = "产品列表";
      } else if (e == "2-1") {
        this.SPlist.type = "threeMetersCounter";
        this.titleType = "三米柜台";
      } else if (e == "2-2") {
        this.SPlist.type = "newRetail";
        this.titleType = "新零售";
      }
      this.state = 1;
      this.SPlist.category = "";
      this.SPlist.style = "";
      this.SPlist.button = "";
      this.SPlist.texture = [];
      this.SPlist.technology = [];
      this.SPlist.pricingManner = "";
      this.SPlist.broadHeading = "";
      this.SPlist.gem = [];
      this.SPlist.gramWeight = [];
      this.SPlist.price = [];
      this.SPlist.sortName = "";
      this.SPlist.sortType = "";
      this.SPlist.keyword = "";
      this.pageNum = 1;
      this.datalist = [];
      this.dynamicTags = [[], [], [], [], [], [], [], [], [], [], [], []];
      this.getAxios();
      this.getAxiosSp();
    });
    // 输入框获取商品列表
    bus.$on("message", (e) => {
      if (e) {
        e = e.replace(/\s+/g, "");
        this.state = 0;
        this.SPlist.category = "";
        this.SPlist.style = "";
        this.SPlist.button = "";
        this.SPlist.texture = [];
        this.SPlist.technology = [];
        this.SPlist.pricingManner = "";
        this.SPlist.broadHeading = "";
        this.SPlist.gem = [];
        this.SPlist.gramWeight = [];
        this.SPlist.price = [];
        this.SPlist.sortName = "";
        this.SPlist.sortType = "";
        this.SPlist.keyword = e;
        this.pageNum = 1;
        this.datalist = [];
        this.dynamicTags = [[], [], [], [], [], [], [], [], [], [], [], []];
        this.getAxiosSp();
      } else {
        this.pageNum = 1;
        this.getAxiosSp();
      }
    });
  },
  methods: {
    // 按顺序查询
    salesSelection(item) {
      if (item == "sales") {
        this.classFlagTwo = false;
        this.SPlist.sortName = "salesNumbers";
        if (this.classFlag == false) {
          this.classFlag = true;
          this.SPlist.sortType = "DESC";
        }
        // else {
        //   this.classFlag = false;
        // }
      } else if (item == "newTime") {
        this.classFlag = false;
        this.SPlist.sortName = "issuedDate";
        if (this.classFlagTwo == false) {
          this.classFlagTwo = true;
          this.SPlist.sortType = "DESC";
        }
        // else {
        //   this.newTimeFlag = false;
        // }
      }
      this.datalist = [];
      this.getAxiosSp();
    },
    getFilterXF(e, item) {
      if (e == "品类名称") {
        if (this.dynamicTags[1] != undefined) {
          if (this.dynamicTags[1].includes(item)) {
            this.dynamicTags[1].splice(
              this.dynamicTags[1].findIndex((i) => i === item),
              1
            );
          } else {
            this.dynamicTags[1] = [];
            this.dynamicTags[1].push(item);
          }
        } else {
          this.dynamicTags[1] = [];
          this.dynamicTags[1].push(item);
        }
        for (let i = 2; i < this.dynamicTags.length; i++) {
          this.dynamicTags[i] = [];
        }
        this.SPlist.style = "";
        this.SPlist.texture = [];
        this.SPlist.technology = [];
        this.SPlist.pricingManner = "";
        this.SPlist.button = "";
        this.SPlist.adjustable = "";
        this.SPlist.gem = [];
        this.SPlist.gramWeight = [];
        this.SPlist.price = [];
        this.SPlist.sortName = "";
        this.SPlist.sortType = "";
        this.SPlist.keyword = "";
        if (this.SPlist.category == item) {
          this.SPlist.category = "";
        } else {
          this.SPlist.category = item;
        }
        this.getAxios();
      } else if (e == "计价方式") {
        if (this.dynamicTags[2] != undefined) {
          if (this.dynamicTags[2].includes(item)) {
            this.dynamicTags[2].splice(
              this.dynamicTags[2].findIndex((i) => i === item),
              1
            );
          } else {
            this.dynamicTags[2] = [];
            this.dynamicTags[2].push(item);
          }
        } else {
          this.dynamicTags[2] = [];
          this.dynamicTags[2].push(item);
        }
        if (item == "计价") {
          this.dynamicTags[9] = [];
          this.dynamicTags[10] = [];
          this.SPlist.gramWeight = [];
        } else if (item == "计克") {
          this.SPlist.price = [];
          this.dynamicTags[9] = [];
          this.dynamicTags[10] = [];
        }
        if (this.SPlist.pricingManner == item) {
          this.SPlist.pricingManner = "";
        } else {
          this.SPlist.pricingManner = item;
        }
        this.getAxios();
      } else if (e == "款式") {
        if (this.dynamicTags[3] != undefined) {
          if (this.dynamicTags[3].includes(item)) {
            this.dynamicTags[3].splice(
              this.dynamicTags[3].findIndex((i) => i === item),
              1
            );
          } else {
            this.dynamicTags[3] = [];
            this.dynamicTags[3].push(item);
          }
        } else {
          this.dynamicTags[3] = [];
          this.dynamicTags[3].push(item);
        }
        if (this.SPlist.style == item) {
          this.SPlist.style = "";
        } else {
          this.SPlist.style = item;
        }
      } else if (e == "扣子类型") {
        if (this.dynamicTags[4] != undefined) {
          if (this.dynamicTags[4].includes(item)) {
            this.dynamicTags[4].splice(
              this.dynamicTags[4].findIndex((i) => i === item),
              1
            );
          } else {
            this.dynamicTags[4] = [];
            this.dynamicTags[4].push(item);
          }
        } else {
          this.dynamicTags[4] = [];
          this.dynamicTags[4].push(item);
        }
        if (this.SPlist.button == item) {
          this.SPlist.button = "";
        } else {
          this.SPlist.button = item;
        }
      } else if (e == "是否可调节") {
        if (this.dynamicTags[5] != undefined) {
          if (this.dynamicTags[5].includes(item)) {
            this.dynamicTags[5].splice(
              this.dynamicTags[5].findIndex((i) => i === item),
              1
            );
          } else {
            this.dynamicTags[5] = [];
            this.dynamicTags[5].push(item);
          }
        } else {
          this.dynamicTags[5] = [];
          this.dynamicTags[5].push(item);
        }
        if (this.SPlist.adjustable == item) {
          this.SPlist.adjustable = "";
        } else {
          this.SPlist.adjustable = item;
        }
      } else if (e == "材质") {
        if (this.dynamicTags[6] != undefined) {
          if (this.dynamicTags[6].includes(item)) {
            this.dynamicTags[6].splice(
              this.dynamicTags[6].findIndex((i) => i === item),
              1
            );
          } else {
            // this.dynamicTags[6] = [];
            this.dynamicTags[6].push(item);
          }
        } else {
          // this.dynamicTags[6] = [];
          this.dynamicTags[6].push(item);
        }
        if (this.SPlist.texture.includes(item)) {
          this.SPlist.texture.splice(
            this.SPlist.texture.findIndex((i) => i === item),
            1
          );
        } else {
          this.SPlist.texture.push(item);
        }
      } else if (e == "工艺") {
        if (this.dynamicTags[7] != undefined) {
          if (this.dynamicTags[7].includes(item)) {
            this.dynamicTags[7].splice(
              this.dynamicTags[7].findIndex((i) => i === item),
              1
            );
          } else {
            // this.dynamicTags[7] = [];
            this.dynamicTags[7].push(item);
          }
        } else {
          // this.dynamicTags[7] = [];
          this.dynamicTags[7].push(item);
        }
        if (this.SPlist.technology.includes(item)) {
          this.SPlist.technology.splice(
            this.SPlist.technology.findIndex((i) => i === item),
            1
          );
        } else {
          this.SPlist.technology.push(item);
        }
      } else if (e == "宝石") {
        if (this.dynamicTags[8] != undefined) {
          if (this.dynamicTags[8].includes(item)) {
            this.dynamicTags[8].splice(
              this.dynamicTags[8].findIndex((i) => i === item),
              1
            );
          } else {
            // this.dynamicTags[8] = [];
            this.dynamicTags[8].push(item);
          }
        } else {
          // this.dynamicTags[8] = [];
          this.dynamicTags[8].push(item);
        }
        if (this.SPlist.gem.includes(item)) {
          this.SPlist.gem.splice(
            this.SPlist.gem.findIndex((i) => i === item),
            1
          );
        } else {
          this.SPlist.gem.push(item);
        }
      } else if (e == "克重") {
        if (this.dynamicTags[9] != undefined) {
          if (this.dynamicTags[9].includes(item)) {
            this.dynamicTags[9].splice(
              this.dynamicTags[9].findIndex((i) => i === item),
              1
            );
          } else {
            // this.dynamicTags[9] = [];
            this.dynamicTags[9].push(item);
          }
        } else {
          // this.dynamicTags[9] = [];
          this.dynamicTags[9].push(item);
        }
        if (this.SPlist.gramWeight.includes(item)) {
          this.SPlist.gramWeight.splice(
            this.SPlist.gramWeight.findIndex((i) => i === item),
            1
          );
        } else {
          this.SPlist.gramWeight.push(item);
        }
      } else if (e == "价格") {
        if (this.dynamicTags[10] != undefined) {
          if (this.dynamicTags[10].includes(item)) {
            this.dynamicTags[10].splice(
              this.dynamicTags[10].findIndex((i) => i === item),
              1
            );
          } else {
            // this.dynamicTags[10] = [];
            this.dynamicTags[10].push(item);
          }
        } else {
          // this.dynamicTags[10] = [];
          this.dynamicTags[10].push(item);
        }
        if (this.SPlist.price.includes(item)) {
          this.SPlist.price.splice(
            this.SPlist.price.findIndex((i) => i === item),
            1
          );
        } else {
          this.SPlist.price.push(item);
        }
      } else if (e == "尺寸") {
        if (this.dynamicTags[11] != undefined) {
          if (this.dynamicTags[11].includes(item)) {
            this.dynamicTags[11].splice(
              this.dynamicTags[11].findIndex((i) => i === item),
              1
            );
          } else {
            // this.dynamicTags[10] = [];
            this.dynamicTags[11].push(item);
          }
        } else {
          // this.dynamicTags[11] = [];
          this.dynamicTags[11].push(item);
        }
        if (this.SPlist.size.includes(item)) {
          this.SPlist.size.splice(
            this.SPlist.size.findIndex((i) => i === item),
            1
          );
        } else {
          this.SPlist.size.push(item);
        }
      }
      this.SPlist.keyword = "";
      // 清空搜索框的值
      bus.$emit("keyword", this.SPlist.keyword);
      this.pageNum = 1;
      this.getAxiosSp();
    },
    mouseLeave(e) {
      e.gouwuche = false;
      this.$set(this.datalist, e);
      this.$forceUpdate();
    },
    mouseOver(e) {
      e.gouwuche = true;
      this.$set(this.datalist, e);
      this.$forceUpdate();
    },
    // 获取改变筛选系列条件
    getFilterXL(e) {
      this.SPlist.category = "";
      this.SPlist.style = "";
      this.SPlist.texture = [];
      this.SPlist.technology = [];
      this.SPlist.pricingManner = "";
      this.SPlist.button = "";
      this.SPlist.adjustable = "";
      this.SPlist.gem = [];
      this.SPlist.gramWeight = [];
      this.SPlist.price = [];
      this.SPlist.sortName = "";
      this.SPlist.sortType = "";
      this.SPlist.keyword = "";
      if (this.dynamicTags[0].includes(e)) {
        this.SPlist.broadHeading = "";
        this.dynamicTags = [[], [], [], [], [], [], [], [], [], [], [], []];
        this.dynamicTags[0] = [];
      } else {
        this.SPlist.broadHeading = e;
        this.dynamicTags = [[], [], [], [], [], [], [], [], [], [], [], []];
        this.dynamicTags[0].push(e);
      }
      // 清空搜索框的值
      bus.$emit("keyword", this.SPlist.keyword);
      this.getAxios();
      this.getAxiosSp();
    },
    // 系列更多点击函数
    showbxcp() {
      if ($(".box_fliter_bixing_mc").height() > 31) {
        $(".box_fliter_bixing_mc").css("overflow", "hidden");
        $(".box_fliter_bixing_mc").css("height", "31");
        $(".box_filter_bx_gengduo div").removeClass("box_filter_hezi_top");
        $(".box_filter_bx_gengduo div").addClass("box_filter_hezi");
        this.FilterBXGD = "更多";
      } else {
        $(".box_fliter_bixing_mc").css("overflow", "none");
        $(".box_fliter_bixing_mc").css("height", "auto");
        $(".box_filter_bx_gengduo div").removeClass("box_filter_hezi");
        $(".box_filter_bx_gengduo div").addClass("box_filter_hezi_top");
        this.FilterBXGD = "收起";
      }
    },
    showzxcp() {
      if ($(".box_fliter_zhuaxing_mc").height() > 31) {
        $(".box_fliter_zhuaxing_mc").css("overflow", "hidden");
        $(".box_fliter_zhuaxing_mc").css("height", "31");
        $(".box_filter_zx_gengduo div").removeClass("box_filter_hezi_top");
        $(".box_filter_zx_gengduo div").addClass("box_filter_hezi");
        this.FilterPLGD = "更多";
      } else {
        $(".box_fliter_zhuaxing_mc").css("overflow", "none");
        $(".box_fliter_zhuaxing_mc").css("height", "auto");
        $(".box_filter_zx_gengduo div").removeClass("box_filter_hezi");
        $(".box_filter_zx_gengduo div").addClass("box_filter_hezi_top");
        this.FilterPLGD = "收起";
      }
    },
    showxfcp() {
      if ($(".box_fliter_xiangfa_mc").height() > 30) {
        $(".box_fliter_xiangfa_mc").css("overflow", "hidden");
        $(".box_fliter_xiangfa_mc").css("height", "30");
        $(".box_filter_xf_gengduo div").removeClass("box_filter_hezi_top");
        $(".box_filter_xf_gengduo div").addClass("box_filter_hezi");
        this.FilterXFGD = "更多";
      } else {
        $(".box_fliter_xiangfa_mc").css("overflow", "none");
        $(".box_fliter_xiangfa_mc").css("height", "auto");
        $(".box_filter_xf_gengduo div").removeClass("box_filter_hezi");
        $(".box_filter_xf_gengduo div").addClass("box_filter_hezi_top");
        this.FilterXFGD = "收起";
      }
    },
    showkscp() {
      if ($(".box_fliter_kuanshi_mc").height() > 31) {
        $(".box_fliter_kuanshi_mc").css("overflow", "hidden");
        $(".box_fliter_kuanshi_mc").css("height", "31");
        $(".box_filter_ks_gengduo div").removeClass("box_filter_hezi_top");
        $(".box_filter_ks_gengduo div").addClass("box_filter_hezi");
        this.FilterKSGD = "更多";
      } else {
        $(".box_fliter_kuanshi_mc").css("overflow", "none");
        $(".box_fliter_kuanshi_mc").css("height", "auto");
        $(".box_filter_ks_gengduo div").removeClass("box_filter_hezi");
        $(".box_filter_ks_gengduo div").addClass("box_filter_hezi_top");
        this.FilterKSGD = "收起";
      }
    },

    // 筛选条件展开-收起
    boxFilterUnfold() {
      this.show_guanjianci = !this.show_guanjianci;
      if (!this.show_guanjianci) {
        this.logo = require("../Img/List/zhankai.png");
        $(".img_zhankai").css("width", "14px");
        $(".img_zhankai").css("height", "14px");
        $(".img_zhankai").css("padding-bottom", "0px");
      } else {
        this.logo = require("../Img/List/shouqi.png");
        $(".img_zhankai").css("width", "14px");
        $(".img_zhankai").css("height", "2px");
        $(".img_zhankai").css("padding-bottom", "5px");
      }
    },
    // 分页组件切换页数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAxiosSp();
    },
    // 分页组件切换
    handleCurrentChange(val) {
      this.pageNum = val;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.getAxiosSp();
    },
    // 获取商品列表属性
    getitem(data) {
      bus.$emit("getitem", data);
      this.$router.push({ path: "/order", query: { id: data.styleNumber } });
    },
    // 筛选清空
    deleteFilet() {
      this.dynamicTags = [[], [], [], [], [], [], [], [], [], [], [], []];
      (this.SPlist = {
        broadHeading: "", //大类
        category: "", //品类
        style: "", //款式
        texture: [], //材质
        technology: [], //工艺
        pricingManner: "", //计价方式
        gem: [], //宝石
        button: "", //扣子类型
        size: [], //尺寸
        gramWeight: [], //克重
        adjustable: "", //是否可调节
        price: [], //价格
        sortName: "", //排序字段
        sortType: "", //排序方式
        keyword: "",
        start: "",
        end: "",
      }),
        this.getAxios();
      this.getAxiosSp();
    },
    // 删除标签页
    handleClose(tag) {
      for (let i = 0; i < this.dynamicTags.length; i++) {
        if (Array.isArray(this.dynamicTags[i])) {
          if (this.dynamicTags[i].indexOf(tag) != -1) {
            this.dynamicTags[i].splice(this.dynamicTags[i].indexOf(tag), 1);
          }
        }
      }
      this.$forceUpdate();
      if (tag == this.SPlist.broadHeading) {
        this.deleteFilet();
      } else if (tag == this.SPlist.category) {
        this.SPlist.category = "";
        this.getAxios();
      } else if (tag == this.SPlist.pricingManner) {
        this.SPlist.pricingManner = "";
        this.getAxios();
      } else if (tag == this.SPlist.adjustable) {
        this.SPlist.adjustable = "";
        this.getAxios();
      } else if (tag == this.SPlist.style) {
        this.SPlist.style = "";
        this.getAxios();
      } else if (tag == this.SPlist.button) {
        this.SPlist.button = "";
        this.getAxios();
      } else {
        for (let i = 0; i < this.SPlist.texture.length; i++) {
          if (this.SPlist.texture[i] == tag) {
            this.SPlist.texture.splice(i, 1);
          }
        }
        for (let i = 0; i < this.SPlist.technology.length; i++) {
          if (this.SPlist.technology[i] == tag) {
            this.SPlist.technology.splice(i, 1);
          }
        }
        for (let i = 0; i < this.SPlist.gem.length; i++) {
          if (this.SPlist.gem[i] == tag) {
            this.SPlist.gem.splice(i, 1);
          }
        }
        for (let i = 0; i < this.SPlist.size.length; i++) {
          if (this.SPlist.size[i] == tag) {
            this.SPlist.size.splice(i, 1);
          }
        }
        for (let i = 0; i < this.SPlist.gramWeight.length; i++) {
          if (this.SPlist.gramWeight[i] == tag) {
            this.SPlist.gramWeight.splice(i, 1);
          }
        }
        for (let i = 0; i < this.SPlist.price.length; i++) {
          if (this.SPlist.price[i] == tag) {
            this.SPlist.price.splice(i, 1);
          }
        }
      }
      this.pageNum = 1;
      this.getAxiosSp();
    },
    // 获取筛选条件
    getAxios() {
      var that = this;
      var url = "/direct/goods/condition";
      that
        .$axios({
          url: url,
          method: "POST",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify({
            broadHeading: that.SPlist.broadHeading,
            category: that.SPlist.category,
            pricingManner: that.SPlist.pricingManner,
            type: that.SPlist.type,
          }),
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.KeyWordsList = res.data.data;
          }
        });
    },
    // 获取商品列表
    getAxiosSp() {
      var that = this;
      that.withWithoutShow = false;
      that.loading = true;
      var copeSPlist = JSON.parse(JSON.stringify(that.SPlist));
      if (this.titleType == "产品列表") {
        copeSPlist.type = "";
      } else if (this.titleType == "三米柜台") {
        copeSPlist.type = "三米柜台";
      } else if (this.titleType == "新零售") {
        copeSPlist.type = "新零售";
      }
      console.log("222", copeSPlist.type);
      var url = `/direct/goods/paging?pageSize=${that.pageSize}&pageNum=${that.pageNum}`;
      that
        .$axios({
          url: url,
          method: "POST",
          cache: false,
          headers: {
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
          data: JSON.stringify(copeSPlist),
        })
        .then((res) => {
          if (res.data.code == 0) {
            that.datalist = [];
            that.loading = false;
            that.datalist = res.data.rows;
            that.datalist = that.datalist.map((val) => {
              val.gouwuche = false;
              return val;
            });
            that.total = res.data.total;
            if (res.data.total > 0) {
              that.withWithoutShow = false;
            } else if (res.data.total == 0) {
              that.withWithoutShow = true;
            }
          }
        });
    },
    dianji() {
      this.$router.push({ path: "/order" });
    },
  },
  deactivated() {
    this.datalist = this.datalist.map((val) => {
      val.gouwuche = false;
      return val;
    });
  },
};
</script>

<style>
.el-radio__input.is-checked .el-radio__inner {
  border-color: rgb(236, 147, 104) !important;
  background: rgb(236, 147, 104) !important;
}
.el-radio__input.is-checked + .el-radio__label {
  color: rgb(236, 147, 104) !important;
}
.shoppingpush {
  position: absolute;
  right: -15px;
  bottom: 18px;
}
.salesNumbersClass {
  position: absolute;
  right: -10px;
  bottom: 14px;
}
.boe_fenye .el-pagination__total {
  line-height: 42px !important;
  color: #ec9368;
  font-size: 16px !important;
}
.boe_fenye .el-pagination__jump {
  color: #ec9368;
  font-size: 16px;
}
.boe_fenye .el-pagination__jump .el-input__inner {
  height: 42px !important;
  width: 40px;
}
.el-scrollbar__view .selected {
  color: #cdcdcd;
}
.el-scrollbar__view li {
  color: #ec9368;
}
.boe_fenye .el-input__inner {
  width: 102px;
  height: 42px !important;
  border: 1px solid #cdcdcd;
  color: #ec9368;
  font-size: 16px !important;
}
.boe_fenye .btn-next i::before {
  color: #ec9368;
  font-size: 16px;
  line-height: 42px;
}
.boe_fenye .btn-prev i::before {
  color: #ec9368;
  font-size: 16px;
  line-height: 42px;
}
.boe_fenye .active {
  color: #fff !important;
  background-color: #ec9368;
}
.boe_fenye .el-pager li {
  color: #ec9368;
  min-width: 42px;
  height: 42px;
  line-height: 42px !important;
  font-size: 16px;
}
.boe_fenye .el-pager li:hover {
  color: #fff;
  background-color: #ec9368;
}
.boe_fenye .number {
  border: 1px solid #cdcdcd;
  margin: 0 2px;
}
.el-pager li.active + li {
  border-left: 1px solid #cdcdcd !important;
}
.box_SP_bianhao {
  margin-top: 15px;
  font-size: 20px;
  margin-left: 14px;
  color: #ec9368;
}
.box_SP_title {
  font-size: 18px;
  color: #000;
  margin-top: 10px;
  margin-left: 14px;
}
.box_input .el-input__inner {
  height: 100%;
  padding-left: 50px;
  background-color: #f3f3f3;
  border-radius: 5px;
}
.box_input .el-icon-search:before {
  font-size: 18px;
}
.box_input .el-input__inner::placeholder {
  padding-left: 10px;
  color: #999;
  font-size: 18px !important;
}
.box_input .el-input__prefix {
  left: 24px;
}
.box_filter_shaixuan .el-tag {
  background-color: #fff2ea;
  border-radius: 0;
  /* width: 114px; */
  font-size: 16px;
  color: #000;
  margin-left: 18px;
  height: 34px;
  border: 1px solid #ec9368;
}
.box_filter_shaixuan .el-tag i::before {
  line-height: 34px;
}
.box_filter_shaixuan .el-tag i {
  border-radius: 0;
  width: 34px;
  color: #000;
  height: 32px;
  left: 10px;
  top: -2px;
}
.box_filter_shaixuan span:hover {
  /* border: 1px solid red; */
  cursor: pointer;
}
.box_filter_shaixuan .el-tag i:hover {
  background: #ec9368;
}
</style>

<style scoped>
.box_biankuang_shuaixuan {
  /* box-shadow: 0px 6px 8px #f5f5f5; */
}
.img_zhankai {
  width: 14px;
  height: 2px;
  padding-bottom: 5px;
  cursor: pointer;
  margin-left: 14px;
}
.box_filter_bx_gengduo {
  float: right;
  cursor: pointer;
  height: 20px;
  color: #999;
  font-size: 14px;
  display: inline-block;
  margin-right: 20px;
}
.box_filter_zx_gengduo {
  float: right;
  cursor: pointer;
  height: 20px;
  color: #999;
  font-size: 14px;
  display: inline-block;
  margin-right: 20px;
}
.box_filter_ks_gengduo {
  float: right;
  cursor: pointer;
  height: 20px;
  color: #999;
  font-size: 14px;
  display: inline-block;
  margin-right: 20px;
}
.box_filter_xf_gengduo {
  float: right;
  cursor: pointer;
  height: 20px;
  color: #999;
  font-size: 14px;
  display: inline-block;
  margin-right: 20px;
}
.box_filter_pl_gengduo {
  float: right;
  cursor: pointer;
  height: 20px;
  color: #999;
  font-size: 14px;
  display: inline-block;
  margin-right: 20px;
}
.box_filter_xl_gengduo {
  float: right;
  cursor: pointer;
  display: inline-block;
  color: #999;
  font-size: 14px;
  margin-right: 20px;
}
.box_fliter_xl_gengduo {
  display: inline-block;
  width: 1000px;
  height: 31px;
  overflow: hidden;
  position: relative;
  top: -10px;
  line-height: 40px;
}
.box_fliter_bixing_mc {
  display: inline-block;
  width: 1000px;
  height: 31px;
  line-height: 40px;
  position: relative;
  top: -10px;
  overflow: hidden;
}
.box_fliter_zhuaxing_mc {
  display: inline-block;
  width: 1000px;
  height: 31px;
  line-height: 40px;
  position: relative;
  top: -10px;
  overflow: hidden;
}
.box_fliter_kuanshi_mc {
  display: inline-block;
  width: 1000px;
  height: 31px;
  line-height: 40px;
  position: relative;
  top: -10px;
  overflow: hidden;
}
.box_fliter_xiangfa_mc {
  display: inline-block;
  width: 1000px;
  height: 30px;
  line-height: 40px;
  position: relative;
  top: -10px;
  overflow: hidden;
}
.box_fliter_pl_mc {
  display: inline-block;
  width: 1000px;
  height: 31px;
  line-height: 40px;
  position: relative;
  top: -10px;
  overflow: hidden;
}
.box_fliter_xl_mc:hover {
  color: #ec9368;
}
.box_fliter_xl_mc {
  display: inline-block;
  cursor: pointer;
  margin-left: 25px;
}
.box_fliter_xl_mc:first-child {
  margin-left: 0;
}
.box_filter_xilie {
  width: 1180px;
  margin-left: 20px;
  margin-top: 20px;
  /* margin-bottom: 20px; */
}
.box_filter_xuxian {
  border-top: 1px dashed #cccccc;
  height: 1px;
  overflow: hidden;
  width: 1160px;
  margin: 0 auto;
}
.box_btoom_conten {
  width: 100%;
  height: 400px;
  background-color: #212529;
  margin-top: 84px;
}
.box_btoom {
  width: 1200px;
  margin: 0 auto;
}
.box_total {
  height: 42px;
  display: inline-block;
  position: relative;
  top: 10px;
  right: 28px;
}
.boe_fenye {
  width: 1200px;
  margin: 0 auto;
  margin-top: 68px;
  text-align: center;
}
.img_chirld {
  width: 100%;
  height: 100%;
}
.box_Img_chirld {
  width: 284px;
  background-size: auto 100%;
  height: 284px;
}
.box_Img_top {
  display: flex;
  flex-wrap: wrap;
}
.box_Img_list:hover {
  border: 1px solid #ec9368;
  cursor: pointer;
}
.box_Img_list {
  margin-bottom: 20px;
  font-size: 0;
  /* margin-right: 21px; */
  /* box-sizing: border-box; */
  position: relative;
  width: 284px;
  height: 372px;
  /* padding-right: 22px; */
}
.box_Img_top :nth-child(n) {
  margin-right: 19px;
}
.box_Img :nth-child(3n) {
  margin-right: 19px;
}
.box_Img :nth-child(2n) {
  margin-right: 18px;
}
.box_Img_top :nth-child(4n) {
  margin-right: 0px;
}
/* .box_Img_list :nth-child(n){
  margin-right: 0px;
}
.box_Img_list :nth-child(3n){
  margin-right: 0px;
} 
.box_Img_list :nth-child(2n){
  margin-right: 0px;
} 
.box_Img_list :nth-child(4n){
  margin-right: 0px;
}  */
.box_Img {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px;
}
.box_filter_hezi {
  width: 10px;
  height: 10px;
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  display: inline-block;
  margin-bottom: 3px;
  margin-left: 8px;
  transform: rotate(225deg);
}
.box_filter_hezi_top {
  width: 10px;
  height: 10px;
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  display: inline-block;
  margin-bottom: -3px;
  margin-left: 8px;
  transform: rotate(45deg);
}
.box_filter_qingkong {
  color: #ff0000;
  font-size: 16px;
}
.box_filter_zhankai {
  font-size: 16px;
  color: #ccac70;
  float: right;
  cursor: pointer;
  margin-right: 20px;
  line-height: 50px;
  display: inline-block;
}
/* .box_filter_hezi:hover{
  background-color: red;
} */
.box_input {
  height: 34px;
  width: 304px;
  line-height: 50px;
}
.Product {
  cursor: pointer;
  font-size: 14px;
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 64px;
  /* text-align: center; */
  /* line-height: 30px; */
  /* color: #ccac70; */
  /* border-bottom: 2px solid #ccac70; */
}
.Product_two {
  cursor: pointer;
  font-size: 14px;
  padding-top: 16px;
  padding-right: 64px;
}
.Product_zhiding {
  cursor: pointer;
  font-size: 14px;
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 64px;
}
.bottom_chanping {
  width: 116px;
  padding-top: 15px;
  border-bottom: 2px solid #ccac70;
}
.box_shuqain {
  width: 100%;
  box-shadow: 0px 8px 12px #f5f5f5;
}
.box_filter_top {
  /* height: 74px; */
  width: 1200px;
  margin: 0 auto;
  /* margin-top: 28px; */
  /* min-height: 500px; */
  /* border: 1px solid #999; */
}
.goodsBox {
  min-height: 500px;
}
.box_filter {
  /* display: flex; */
  /* height: 74px; */
  /* overflow: hidden; */
  /* justify-content: space-between; */
  /* border: 1px solid #eee;
  width: 1200px;
  margin: 0 auto;
  margin-top: 28px; */
  padding-top: 10px;
  padding-bottom: 10px;
}
.box_filter_shaixuan {
  font-size: 16px;
  line-height: 50px;
  margin-left: 20px;
  display: inline-block;
  width: 1025px;
  color: #000;
}
.rel_commodity {
  display: flex;
  height: 50px;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}
.detai_box_img {
  background-image: url("../Img/detaile/benner.png");
  width: 100%;
  /* height:40%; */
  /* background-size: 100% 100%; */
  display: flex;
  height: 304px;
  margin: 0 auto;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.city {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px solid gray;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.commodity {
  font-size: 14px;
  width: 200px;
  height: 300px;
  box-sizing: border-box;
  border: 1px solid #fff;
}
.commodity_buttom_p {
  text-align: center;
}
.commodity_p {
  text-align: center;
  padding: 0.2rem;
}
.flex_commodity {
  width: 1200px;
  display: flex;
  flex-wrap: wrap;
}
.box_detail_name {
  width: 284px;
  display: flex;
  justify-content: space-between;
}
.box_Img_list:hover .box_detail_name {
  display: flex;
  justify-content: space-between;
  text-align: left;
}
[v-cloak] {
  display: none;
}
.homeUnFold {
  width: 200px;
  height: 40px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
  margin: auto;
  border: 1px solid rgb(238, 238, 238);
  border-top: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.homeUnFold img {
  width: 23px;
  height: 23px;
  margin-left: 5px;
}
.home_sort {
  width: 1200px;
  margin: auto;
  margin-top: 20px;
  font-size: 16px;
  align-items: center;
  display: flex;
}
.home_sort_hotal {
  color: #999;
  margin: 0 12px 0 12px;
}
.sortClass {
  font-size: 16px;
  color: #000000;
  margin-right: 12px;
}
.sales {
  width: 62px;
  height: 26px;
  cursor: pointer;
  text-align: center;
  line-height: 26px;
  border: 1px solid #e5ecef;
  color: #000000;
}
.priceRangeClass {
  display: flex;
  margin: 0 12px;
}
.priceRangeClass ::v-deep .el-input__inner {
  width: 90px;
  padding: 0 5px;
}
.determine {
  width: 62px;
  height: 26px;
  font-size: 14px;
  cursor: pointer;
  line-height: 26px;
  text-align: center;
  background: #ec9368;
  color: #fff;
}
.classColor {
  background: #ec9368;
  color: #fff;
}
.new_product {
  width: 62px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  box-sizing: border-box;
  border: 1px solid #e5ecef;
  color: #000000;
}
.arrowUp {
  display: inline-block;
  width: 10px;
  height: 14px;
}
/* .el-loading-parent--relative {
  margin: 100px 0 !important;
} */
</style>
